<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header v-if="!propsReadFromProps"/>
    <loading
        :active.sync="loadingMax"
        :is-full-page="true"
    ></loading>
    <b-card class="bCardGlobalXL">
      <div class="divSubtitulo m-1 mb-3 d-flex justify-content-between">
        <p class="textoSubtitulo">Métodos de pago</p>
        <p style="text-align: end" class="textoSubtitulo">Formas de Pago_PTI_01</p>
      </div>

      <div class="mt-2 mb-4"></div>

      <b-row>
        <b-col cols="7">
          <div class="d-flex align-items-start">
            <b-img
                :src="require('@/assets/Logo dentalia-blue.png')"
                alt="Dentalia"
                class="logoDentalia pl-3 mr-5"
                width="130"
            ></b-img>
            <b-img
                :src="require('@/assets/empleado-dentalia.jpg')"
                alt="Dentalia"
                class="logoDentalia"
            ></b-img>
          </div>
          <TerminosYCondiciones style="font-size: 0.9em !important;" class="mb-2"/>
          <b-button variant="outline-secondary" :disabled="loaderRegresar" @click="regresarNegociar()" v-if="!propsReadFromProps">
            <span v-if="loaderRegresar">Cargando <b-spinner small></b-spinner></span>
            <span v-else>Regresar a negociar</span>
          </b-button>
        </b-col>
        <b-col cols="5">
          <b-card class="bCardGlobal">
            <b-row>
              <b-col cols="8">
                <p style="text-align: left; color: #1b81af; font-weight: 600; font-size: .9em;">Formas de pago</p>
              </b-col>
              <b-col cols="4" class="d-flex justify-content-end">
                <b-button
                    class="mr-3 p-0 mt-1"
                    @click="activarModal"
                    style="background-color: white; width: 20px; border-color: white; color: #093974;"
                    v-b-tooltip.hover.left.v-light
                    title="Agregar herramientas de cierre"
                >
                  <em class="engrane_azul_svg"></em>
                </b-button>

                <b-button  size="md"
                    v-b-tooltip.hover.lefttop.v-light variant="outline-info" pill
                    title="Agregar nuevo pago" style="width: 28px; height: 28px; background-color: #1b81af; border-radius: 50%;
                        border: solid 1px #1b81af;" class="mt-1 d-flex align-items-center justify-content-center"
                    @click="abiriModalPago()">
                  <em class="fa fa-plus" style="color: #FFF; margin-top: 2px; margin-left: 1px;"/>
                </b-button>
                <b-button  size="md"
                    v-b-tooltip.hover.lefttop.v-light variant="outline-info" pill
                    title="Editar pagos" style="width: 30px; height: 30px; background-color: #1b81af; border-radius: 50%;
                        border: solid 1px #1b81af;" class="ml-2 mt-1 d-flex align-items-center justify-content-center" :class="clickBotonEdit || pagosAnteriores.length < 1 && pagosActuales.length < 1 ? '' : 'jello-vertical'"
                    :disabled="
                        pagosAnteriores.length < 1 && pagosActuales.length < 1
                      "
                    @click="abrirModalEditar()">
                  <em class="fa fa-edit" style="color: #FFF; margin-top: 2px; margin-left: 1px;"/>
                </b-button>
                <b-button  size="md"
                           v-b-tooltip.hover.lefttop.v-light variant="outline-info" pill
                           title="Configurar plazos para impresión" style="width: 30px; height: 30px; background-color: #1b81af; border-radius: 50%;
                        border: solid 1px #1b81af;" class="ml-2 mt-1 d-flex align-items-center justify-content-center"
                           @click="abrirModalPlazos()">
                  <em class="fa fa-calendar" style="color: #FFF; margin-top: -1px; margin-left: 1px;"/>
                </b-button>
              </b-col>
            </b-row>

            <hr class="w-75">

            <div style="min-height: 300px;" class="text-left">
              <div v-if="formaPagoTarjeta.length != 0">
                <b-card class="mt-3" style="border-radius: 10px;" v-for="(tarjeta, indice) in formaPagoTarjeta" :key="indice">
                  <div v-if="tarjeta.plazoFijo && !tarjeta.tieneMsi">
                    <p style="font-size: .8em; font-weight: 500">Plan de Pago</p>
                    <b-row>
                      <b-col class="pr-0">
                        <p style="color: #1b81af; font-weight: bold"><em  class="tarjeta"></em> TDC (con plazos fijos)</p>
                      </b-col>
                      <b-col class="text-right p-0">
                          monto a financiar: 
                      </b-col>
                      <b-col class="text-right pr-2 pl-0" cols="2">
                          <p style="color: #1b81af; font-weight: bold">{{ tarjeta.montoPagar | monedaDecimales }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="pr-0">
                        {{tarjeta.plazo}} pagos mensuales de aprox <p style="color: #1b81af; font-weight: bold">{{ tarjeta.pagoMensual | monedaSinDecimal }}</p>
                      </b-col>
                      <b-col class="text-right p-0">
                          costo de financiamiento (IVA incluido): 
                      </b-col>
                      <b-col class="text-right pr-2 pl-0" cols="2">
                          <p style="color: #1b81af; font-weight: bold">{{ tarjeta.costoFinanciamiento | monedaDecimales }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col></b-col>
                      <b-col class="text-right p-0">
                          total: 
                      </b-col>
                      <b-col class="text-right pr-2 pl-0" cols="2">
                          <p style="color: #1b81af; font-weight: bold">{{ tarjeta.total | monedaDecimales }}</p>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else-if="!tarjeta.plazoFijo && tarjeta.tieneMsi">
                    <p style="font-size: .8em; font-weight: 500">Plan de Pago</p>
                    <b-row>
                      <b-col>
                        <p style="color: #1b81af; font-weight: bold"><em  class="tarjeta"></em> TDC (con MSI):</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        {{tarjeta.plazo}} pagos mensuales de aprox <p style="color: #1b81af; font-weight: bold">{{ tarjeta.pagoMensual | monedaSinDecimal }}</p>
                      </b-col>
                      <b-col class="text-right p-0">
                          total: 
                      </b-col>
                      <b-col class="text-left p-0" cols="2">
                          <p style="color: #1b81af; font-weight: bold">{{ tarjeta.montoPagar | monedaSinDecimal }}</p>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else>
                    <p style="font-size: .8em; font-weight: 500">Contado</p>
                    <b-row>
                      <b-col>
                        <p style="color: #1b81af; font-weight: bold"><em  class="tarjeta"></em> TDC</p>
                      </b-col>
                      <b-col class="text-right p-0">
                        Total:
                      </b-col>
                      <b-col class="text-left p-0" cols="2">
                        <p style="color: #1b81af; font-weight: bold">{{ tarjeta.montoPagar | monedaSinDecimal }}</p>
                      </b-col>
                    </b-row>
                  </div>
                </b-card>
              </div>
              <div class="m-2" v-if="formaPagoFinanciamiento.length != 0">
                <b-card class="mt-3" style="border-radius: 10px;" v-for="(financiamiento, indice) in formaPagoFinanciamiento" :key="indice">
                  <p style="font-size: .8em; font-weight: 500">Plan de pago</p>
                  <img v-if="financiamiento.idFinanciera === 2" style="position: relative; height: 46px; width: 154px;" :src="'data:image/png;base64,' + dentaliaPayImg " alt="dentaliaPayImg"/>
                  <img v-if="financiamiento.idFinanciera === 3" style="position: relative; height: 46px; width: 154px;" :src="'data:image/png;base64,' + aPlazoImg " alt="APlazoImg"/>
                  <img v-if="financiamiento.idFinanciera === 4" style="position: relative; height: 46px; width: 154px;" :src="'data:image/png;base64,' + kueskiPayImg " alt="kuekiPayImg"/>
                  <br>
                  <b-row>
                    <b-col>
                      <p>{{financiamiento.plazo}} pagos quincenales</p>
                    </b-col>
                    <b-col class="text-right p-0">
                        monto a financiar: 
                    </b-col>
                    <b-col class="text-left p-0" cols="2">
                        <p style="color: #1b81af; font-weight: bold">{{ financiamiento.montoPagar | monedaSinDecimal }}</p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-center">
                      <p style="font-size: .75em; font-weight: 600; color: orangered;">Sujeto a revisión y aprovación</p>
                    </b-col>
                  </b-row>
                </b-card>
              </div>

              <div v-if="formaPagoTransferencia.length !== 0">
                <b-card class="mt-3" style="border-radius: 10px;" v-for="(efectivo, indice) in formaPagoTransferencia" :key="indice">
                  <p style="font-size: .8em; font-weight: 500">Contado</p>
                  <b-row>
                    <b-col>
                      <p v-if="efectivo.formaPagoNombre === 'TRANSFERENCIA'" style="font-size: .8em; color: #1b81af; font-weight: bold"><em class="billete sm"></em> {{ efectivo.formaPagoNombre }}</p>
                      <p v-else style="font-size: .8em; color: #1b81af; font-weight: bold"><em  class="tarjeta"></em> {{ efectivo.formaPagoNombre }}</p>
                    </b-col>
                    <b-col class="text-right p-0">
                        Total: 
                    </b-col>
                    <b-col class="text-left p-0" cols="2">
                        <p style="color: #1b81af; font-weight: bold">{{ efectivo.montoPagar | monedaSinDecimal }}</p>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
              <div v-if="formaPagoTarjeta.length == 0 && formaPagoFinanciamiento.length == 0 && formaPagoTransferencia.length == 0" class="mt-3 d-flex justify-content-center align-items-center" style=" min-height: 50vh;">
                <p style="font-size: .9em;">Sin metodos de pago</p>
              </div>
            </div>

            <hr class="w-75">

            <div class="mt-4">
              <div v-if="montoTotalDescuentoCupon > 0" class="d-flex justify-content-between">
                <p style="font-weight: 600; font-size: .9em;">Subtotal a pagar:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{
                    totalInversionVista | monedaSinDecimal
                  }}
                </p>
              </div>
              <div v-if="tdcFinanciamiento" class="d-flex justify-content-between">
                <p style="font-weight: 600; font-size: .9em;">Subtotal a pagar:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{
                     totalInversionVista | monedaDecimales
                  }}
                </p>
              </div>
              <div v-if="montoTotalDescuentoCupon > 0" class="d-flex justify-content-between">
                <p style="color: #1baf2f; font-weight: 600; font-size: .9em;">Descuento especial:</p>
                <p style="color: #1baf2f; font-weight: 600; font-size: .9em;" v-if="validacionesCupon.tipoDescuento == 2">
                  {{
                    montoTotalDescuentoCupon | monedaSinDecimal
                  }}
                </p>
                <p style="color: #1baf2f; font-weight: 600; font-size: .9em;" v-else>
                  {{
                    montoTotalDescuentoCupon | monedaSinDecimal
                  }}
                </p>
              </div>
              <div v-if="tdcFinanciamiento" class="d-flex justify-content-between">
                <p style="font-weight: 600; font-size: .9em;">Costo de financiamiento(IVA incluido):</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{
                    costoFinanciamientoConIva | monedaDecimales
                  }}
                </p>
              </div>
              <div class="d-flex justify-content-between" v-if="montoTotalDescuentoCupon > 0 && !tdcFinanciamiento"> <!-- Montoss de cupon -->
                <p style="font-weight: 600; font-size: .9em;">Inversión total:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{
                    totalGastado | monedaSinDecimal
                  }}
                </p>
              </div>
              <div v-else-if="tdcFinanciamiento" class="d-flex justify-content-between">
                <p style="font-weight: 600; font-size: .9em;">Inversión total:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{
                    totalInversionVista + costoFinanciamientoConIva | monedaDecimales
                  }}
                </p>
              </div>
              <div class="d-flex justify-content-between" v-else>
                <p style="font-weight: 600; font-size: .9em;">Inversión total:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{
                    totalInversionVista | monedaSinDecimal
                  }}
                </p>
              </div>
              <div v-if="tdcFinanciamiento" class="d-flex justify-content-between">
                <p style="font-weight: 600; font-size: .9em;">Total pagado:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{
                     totalGastado + costoFinanciamientoConIva | monedaDecimales
                  }}
                </p>
              </div>
              <div class="d-flex justify-content-between" v-if="montoTotalDescuentoCupon > 0">
                <p style="font-weight: 600; font-size: .9em;">Inversión total restante:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{ inversionTotalRestante | monedaSinDecimal }}
                </p>
              </div>
              <div class="d-flex justify-content-between" v-else-if="tdcFinanciamiento">
                <p style="font-weight: 600; font-size: .9em;">Inversión total restante:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{ restanteActual | monedaDecimales }}
                </p>
              </div>
              <div class="d-flex justify-content-between" v-else>
                <p style="font-weight: 600; font-size: .9em;">Inversión total restante:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                  {{ restanteActual | monedaSinDecimal }}
                </p>
              </div>
              <div
                  v-if="datosCotizacionFinal.planExiste"
                  class="d-flex justify-content-between"
              >
                <template v-if="datosCotizacionFinal.idPacienteVale != null">
                  <p style="font-weight: 600">Ahorro por vale</p>
                  <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                    {{
                      datosCotizacionFinal.totalDescuentoVale
                          | monedaSinDecimal
                    }}
                  </p>
                </template>

                <template v-else>
                  <p style="font-weight: 600; font-size: .9em;">Ahorro por plan:</p>
                  <p style="color: #1b81af; font-weight: 600; font-size: .9em;">
                    {{
                      datosCotizacionFinal.totalDescuentoPlan
                          | monedaSinDecimal
                    }}
                  </p>
                </template>
              </div>
              <div v-if="!tdcFinanciamiento" class="d-flex justify-content-between">
                <p style="font-weight: 600; font-size: .9em;">Total pagado:</p>
                <p style="color: #1b81af; font-weight: 600; font-size: .8em;">
                  {{ totalGastado | monedaSinDecimal }}
                </p>
              </div>
            </div>
            <b-button variant="primary" style="
                        border-radius: 30px;
                        background-color: #1b81af;
                        border: solid 1px #1b81af
                      "
                      @click="distribuirMontos(false)"
            >
              Continuar
            </b-button>
          </b-card>
        </b-col>
      </b-row>

    </b-card>


    <b-modal size="lg" v-model="modalFormasPago" title="Formas de pago">
      <p>Seleccione un esquema de pago</p>
      <b-form-radio-group id="pago" v-model="esquemaPago" @input="limpiarDatosEsquema()" name="pago">
        <b-form-radio :value="1">Contado</b-form-radio>
        <b-form-radio :value="2">Planes de pago</b-form-radio>
      </b-form-radio-group>
      <!--ESQUEMA CONTADO-->
      <div v-if="esquemaPago == 1">
        <b-row>
          <b-col>
            <div class="m-4">
              <b-form-input
                  v-model="montoAPagar"
                  @keypress="onlyNumber"
                  min="0"
                  type="number"
                  placeholder="Monto a pagar $"
              ></b-form-input>
            </div>
          </b-col>
          <b-col>
            <div class="m-4">
              <b-form-select
                  v-model="formaPagoSeleccionada"
                  :options="formasPago
                    .filter((f) => {
                          return !this.saldoBloqueado || (this.saldoBloqueado && f.idFormaPago != 6);
                        })
                    .filter(f => {return (montoAPagar > 0 || f.idFormaPago === 1) && f.idFormaPago != 7})"
                  value-field="idFormaPago"
                  text-field="nombreForma"
                  disabled-field="activado"
              ></b-form-select>
            </div>
          </b-col>
        </b-row>
      </div>
      <!--ESQUEMA PLANES-->
      <div v-if="esquemaPago == 2">
        <b-row>
          <b-col class="pr-0">
            <div class="m-4">
              <p>Monto a financiar</p>
              <b-form-input
                  :disabled="formaPagoSeleccionada === 2 ? calculoPlazoFijo : calculoFinancieraAtrato"
                  v-model="montoAPagar"
                  @keypress="onlyNumber"
                  min="0"
                  type="number"
                  placeholder="Monto a financiar $"
                  @keyup.enter="calcularMontosPlazoFijo()"
              ></b-form-input>
            </div>
          </b-col>
          <b-col cols="1" class="p-0">
            <div class="d-flex justify-content-between mt-5 pt-4" v-if="formaPagoSeleccionada === 2">
              <em v-if="!calculoPlazoFijo" class="calculadora" @click="calcularMontosPlazoFijo()" v-b-tooltip.hover.auto:title="'Calcular'"></em>
              <em v-else class="editarV5 " style="width: 24px" @click="habilitarMonto()" v-b-tooltip.hover.auto:title="'Editar'"></em>
            </div>
            <div class="d-flex justify-content-between mt-5 pt-4" v-else-if="formaPagoSeleccionada === 7 && financieraSeleccionada === 2">
              <em v-if="!calculoFinancieraAtrato" class="calculadora" @click="obtenerQuincenasFinaciamientoAtrato()" v-b-tooltip.hover.auto:title="'Calcular'"></em>
              <em v-else class="editarV5 " style="width: 24px" @click="habilitarMonto()" v-b-tooltip.hover.auto:title="'Editar'"></em>
            </div>
          </b-col>
          <b-col class="pl-0">
            <div class="m-4">
              <p>Método</p>
              <b-form-select
                  @input="limpiarDatosMetodo()"
                  v-model="formaPagoSeleccionada"
                  :options="formasPago
                    .filter((f) => {
                          return !this.saldoBloqueado || (this.saldoBloqueado && f.idFormaPago != 6);
                        })
                    .filter(f => {return f.idFormaPago === 2 || f.idFormaPago === 7})"
                  value-field="idFormaPago"
                  text-field="nombreForma"
                  disabled-field="activado"
              ></b-form-select>
            </div>
          </b-col>
        </b-row>
        <!--FORMA PAGO TDC-->
        <div v-if="formaPagoSeleccionada === 2">
          <b-row style="color: #093974; font-weight: bold;">
            <b-col></b-col>
            <b-col align="center">
              <p><b-icon icon="credit-card"></b-icon> Tarjeta de crédito</p>
            </b-col>
            <b-col></b-col>
          </b-row>
          <b-table
            hover
            id="tdc"
            :items="registroTablaTdc"
            :fields="encabezadosTdc"
            responsive
            :small="true"
            style="font-size: 12px !important; padding: 0.1rem;"
            fixed
            thead-tr-class="columnasTablaSinColorLetter">
            <template #cell(seleccionado)="row">
              <div class="text-right">
              <b-form-radio-group id="tdc" @input="seleccionarTdc(row.item)" name="tdc">
                <b-form-radio :value="true"></b-form-radio>
              </b-form-radio-group>
              </div>
            </template>
            <template #cell(meses)="row">
              <span >{{row.item.meses}} meses</span>
            </template>
            <template #cell(pagoMensual)="row">
              <span >{{row.item.pagoMensual | monedaEntero}}</span>
            </template>
            <template #cell(costoFinanciamiento)="row">
              <span v-if="row.item.costoFinanciamiento !== 'Sin costo'">{{row.item.costoFinanciamiento | monedaDecimales}}</span>
              <span v-else style="color: #3EBF90; font-weight: 500">{{ row.item.costoFinanciamiento }}</span>
            </template>
            <template #cell(total)="row">
              <span >{{row.item.total | monedaDecimales}}</span>
            </template>
          </b-table>
          <b-row v-if="configuracionesMsi.length === 0">
            <b-col class="text-center">
              <p style="font-size: .75em; font-weight: 600; color: #842511;">No se han encontrado registros de tdc en la clínica</p>
            </b-col>
          </b-row>
          <b-row v-else-if="!calculoPlazoFijo">
            <b-col class="text-center">
              <p style="font-size: .75em; font-weight: 600; color: orangered;">Ingrese un monto en monto a financiar y de clic en el botón de a lado para calcular</p>
            </b-col>
          </b-row>
        </div>
        <!--FORMA PAGO FINANCIAMIENTO-->
        <div v-if="formaPagoSeleccionada === 7">
          <b-row>
            <b-col>
              <div class="m-4">
                <p>Financiera</p>
                <b-form-select
                    v-model="financieraSeleccionada"
                    :options="financieras"
                    value-field="idFinanciera"
                    text-field="financiera"
                    @input="obtenerMinimoFinanciera"
                ></b-form-select>
              </div>
            </b-col>
            <b-col v-if="financieraSeleccionada === 3 || financieraSeleccionada === 4">
              <div class="m-4">
                <p>Plazo de pago</p>
                <b-form-select
                    v-model="plazoFinancieraSeleccionada"
                    :options="financieraSeleccionada === 3 ? aPlazo : kueskiPay"
                    value-field="plazo"
                    text-field="plazo"
                ></b-form-select>
              </div>
            </b-col>
            <b-col v-else></b-col>
          </b-row>
        </div>
        <div class="m-4" v-if="financieraSeleccionada === 2">
          <b-row>
            <b-col class="d-flex justify-content-center text-center mt-2 mb-2">
              <img style="position: relative; height: 46px; width: 154px;" :src="'data:image/png;base64,' + dentaliaPayImg" alt="Dentalia Pay"/>
            </b-col>
          </b-row>
          <br>
          <br>
          <b-row>
            <b-table
              hover
              id="tdc"
              :items="costoFinanciamientoAtrato"
              :fields="encabezadosAtrato"
              responsive
              :small="true"
              style="font-size: 12px !important; padding: 0.1rem;"
              fixed
              thead-tr-class="columnasTablaSinColorLetter">
              <template #cell(seleccionado)="row">
                <b-form-radio-group id="financiamiento" @input="seleccionarTdc(row.item)" name="financiamiento">
                  <b-form-radio :value="true"></b-form-radio>
                </b-form-radio-group>
              </template>
              <template #cell(meses)="row">
                <span >{{row.item.meses}} meses</span>
              </template>
              <template #cell(pagoQuincenal)="row">
                <span >{{row.item.pagoQuincenal | monedaEntero}}</span>
              </template>
              <template #cell(total)="row">
                <span >{{row.item.total | monedaEntero}}</span>
              </template>
            </b-table>
          </b-row>
          <b-row v-if="!calculoFinancieraAtrato">
            <b-col class="text-center">
              <p style="font-size: .75em; font-weight: 600; color: orangered;">Ingrese un monto en monto a financiar y de clic en el botón de a lado para calcular</p>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col class="text-center">
              <p style="font-size: .75em; font-weight: 600; color: orangered;">Los precios están sujetos a revisión y aprovación</p>
            </b-col>
          </b-row>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="outline-info" @click="calcularMonto">
          <span v-if="!guardando">Calcular monto</span>
          <span v-if="guardando">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
            variant="outline-secondary"
            @click="cerrarModalFormas()"
            style="margin-left: 10px"
        >Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal size="lg" v-model="modalHerramientasCierre" hide-footer hide-header no-close-on-backdrop>
      <b-row>
        <b-col class="pl-5 pt-3" cols="1"><em style="font-size: 25px; color: #093974;" class="fa fa-gear"></em></b-col>
        <b-col class="pl-2 pt-3"><p style="color: #093974;"><strong>Herramientas de cierre</strong></p></b-col>
      </b-row>
      <p style="padding-left: 30px;">Ingresa el código para redimir tu herramienta de cierre</p>
      <div style="padding-top: 30px;">
        <b-row>
          <b-col style="padding-left: 100px;">
            <b-input-group class="pl-3" style="border: 1px solid; border-radius: 10px;">
              <b-form-input
                  v-model="codigo"
                  type="text"
                  placeholder="Código de herramientas"
                  style="border-radius: 10px; text-transform: none !important;"
                  class="input-filter"
              ></b-form-input>
              <b-button
                  v-b-tooltip.hover.auto:title="'Quitar codigo'"
                  size="sm"
                  variant="ligth"
                  @click="quitarCodigo()"
                  v-if="validacionesCupon.msjExito"
              >
                <b-icon-x-circle
                    variant="danger"
                ></b-icon-x-circle>
              </b-button>
            </b-input-group>
          </b-col>
          <b-col cols="3">
            <b-button variant="outline-info" v-on:click="validarCodigo()" pill :disabled="codigo === null || montoTotalDescuentoCupon > 0
            || validacionesCupon.msjExito">
              <span>Aplicar</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row v-if="validacionesCupon.msjExito" style="padding-left: 100px; padding-top: 15px;">
          <p v-if="validacionesCupon.tipoDescuento === 1" style="color: #28a745">Descuento:
            -{{ validacionesCupon.cantidadDescuento }}%</p>
          <p v-else style="color: #28a745">Descuento: -{{ validacionesCupon.cantidadDescuento | moneda }}</p>
        </b-row>
        <b-row v-if="!validacionesCupon.msjExito" style="padding-left: 110px; padding-top: 10px;">
          <p style="color: rgb(255, 0, 0);">{{ validacionesCupon.mensajeDeError }}</p>
        </b-row>
        <div style="padding-top: 65px; padding-bottom: 20px;" class="row">
          <div style="padding-left: 250px;">
            <b-button v-if="validacionesCupon.msjExito" variant="primary" @click="aplicarCodigo" pill
                      :disabled="montoTotalDescuentoCupon > 0">
              <span>Guardar</span>
            </b-button>
            <b-button v-else style="background-color: #8AC1D8;" @click="aplicarCodigo"
                      disabled pill>
              <span>Guardar</span>
            </b-button>
          </div>
          <div style="padding-left: 100px;">
            <b-button
                variant="outline-secondary"
                @click="cancelar()"
                style="margin-left: 10px"
                pill
            >Cancelar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        size="lg"
        v-model="modalEditFormasPago"
        title="Resumen formas de pago"
    >
      <div v-if="pagosActuales.length > 0">
        <p>Pagos actuales</p>
        <b-table-simple
            hover
            style="font-size: 14px; margin-bottom: 0rem !important"
            v-if="pago"
        >
          <b-thead class="columnas">
            <b-tr>
              <b-th>Forma de pago </b-th>
              <b-th>Plazo</b-th>
              <b-th>Monto</b-th>
              <b-th>Monto a pagar</b-th>
              <b-th>Monto pendiente</b-th>
              <b-th>Porcentaje</b-th>
              <b-th>Ahorro</b-th>
              <b-th v-if="!pago.descuentoAplicado"></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(pago, index) in pagosActuales" :key="index">
              <b-td>{{ pago.formaPagoNombre }}</b-td>
              <b-td>{{ pago.plazo }}</b-td>
              <b-td class="text-end">{{ pago.monto | monedaSinDecimal }}</b-td>
              <b-td class="text-end">{{
                  pago.montoPagar | monedaSinDecimal
                }}</b-td>
              <b-td class="text-end">{{
                  pago.restante | monedaSinDecimal
                }}</b-td>
              <!--Porcentaje -->
              <b-td>
                <div v-if="!pago.descuentoAplicado">{{ pago.porcentaje }}%</div>
                <div v-else>
                  <span
                      class="text-center"
                      v-on:dblclick="pago.cambiarPorcentaje = true"
                      v-if="!pago.cambiarPorcentaje"
                  >
                    {{ pago.porcentaje }}%
                  </span>
                  <span v-else>
                    <b-form-input
                        type="number"
                        v-model="pago.porcentaje"
                        v-on:keyup.enter="calcularDescuento(index)"
                    ></b-form-input>
                  </span>
                </div>
              </b-td>
              <b-td class="text-end">{{ pago.ahorro | monedaSinDecimal }}</b-td>
              <!--Cancelar -->
              <b-td>
                <b-icon
                    class="punteroMano"
                    icon="x"
                    variant="info"
                    font-scale="2"
                    v-on:click="cancelarForma(pago)"
                ></b-icon>
              </b-td>
              <b-td v-if="!pago.descuentoAplicado">
                <b-spinner variant="info" v-if="pago.cargando"></b-spinner>
                <b-icon
                    class="punteroMano"
                    icon="search"
                    variant="info"
                    font-scale="2"
                    v-on:click="buscarDescuento(index)"
                    v-else
                ></b-icon>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <div
          v-if="pagosAnteriores.length > 0 && pagosActuales.length > 0"
          class="d-flex justify-content-center"
      >
        <div class="v-line-bottom" style="color: white">.</div>
      </div>
      <div class="mt-4" v-if="pagosAnteriores.length > 0">
        <b-table-simple
            class="mt-4"
            hover
            style="font-size: 14px; margin-bottom: 0rem !important"
        >
          <b-thead class="columnas">
            <b-tr>
              <b-th>Forma de pago anterior</b-th>
              <b-th>Plazo</b-th>
              <b-th>Monto</b-th>
              <b-th>Monto a pagar</b-th>
              <b-th>Monto pendiente</b-th>
              <b-th>Porcentaje</b-th>
              <b-th>Ahorro</b-th>
              <b-th>Cancelar</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(pago, index) in pagosAnteriores" :key="index">
              <b-td>{{ pago.formaPagoNombre }}</b-td>
              <b-td>{{ pago.plazo }}</b-td>
              <b-td class="text-end">{{ pago.monto | monedaSinDecimal }}</b-td>
              <b-td class="text-end">{{
                  pago.montoPagar | monedaSinDecimal
                }}</b-td>
              <b-td class="text-end">{{
                  pago.restante | monedaSinDecimal
                }}</b-td>
              <b-td>{{ pago.porcentaje }}%</b-td>
              <b-td class="text-end">{{ pago.ahorro | monedaSinDecimal }}</b-td>
              <!--Cancelar X-->
              <b-td>
                <b-icon
                    class="punteroMano"
                    icon="x"
                    variant="info"
                    font-scale="2"
                    v-on:click="cancelarFormaVista(index)"
                ></b-icon>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <template v-slot:modal-footer>
        <b-button
            variant="outline-secondary"
            @click="modalEditFormasPago = false"
        >Cerrar
        </b-button>
      </template>
    </b-modal>

    <div v-if="modalPlazosAbierto">
      <ConfiguracionPlazosPtiModal :titulo-modal="'Inversión Total'" @cerrar="cerrarModalPlazos" :modalAbierto="modalPlazosAbierto" :inversionTotal="totalInversionVista" :bln-entregable="false" />
    </div>
  </div>
</template>

<script>
import TerminosYCondiciones from "@/components/TerminosYCondiciones.vue";
import {FormaPagoService} from "@/apiServices/formaPago/FormaPagoService";
import VueNotifications from "vue-notifications";
import {CuponesService} from "@/apiServices/cupones/CuponesService";
import {NuevoM2Service} from "@/apiServices/pti/NuevoM2Service";
import Header from "@/components/Header";
import ConfiguracionPlazosPtiModal from "@/components/configuracionPlazosPti/configuracionPlazosPtiModal.vue";

export default {
  name: "MetodosPagov5",
  components: {ConfiguracionPlazosPtiModal, Header, TerminosYCondiciones},
  props: {
    propsReadFromProps: {
      type: Boolean,
      default: false
    },
    propsIdPti: Number,
    propsIdSolicitud: Number,
    propsIdSolicitudEtapa: Number,
    propsIdEtapa: Number,
    editaAnfitrion: Boolean,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      cuponesService: new CuponesService(),
      nuevoM2Service: new NuevoM2Service(),
      formaPagoService: new FormaPagoService(),
      bloquearSelect: false,
      modalHerramientasCierre: false,
      pago: false,
      mostrarMensaje: false,
      enviando: false,
      tipoEvento: false,
      clickBotonEdit: false,
      modalEditFormasPago: false,
      evento: 0,
      codigo: null,
      validacionesCupon: {
        idCupon: null,
        cantidadDescuento: 0,
        tipoDescuento: null,
        tipoAplicacionDescuento: null,
        msjExito: null,
      },
      mensajeError: null,

      datos: [],
      etapas: [],
      herramientaCierre: [],
      opcionPti: null,
      idPti: null,
      idCupon: null,
      idSolicitudEtapa: null,
      idMeses: null,
      idPaciente: null,
      idSesion: 1,
      idTicket: null,
      idEtapa: null,
      idSolicitud: null,
      totalPti: null,
      montoMinimo: null,
      nombrePaciente: "",
      clinica: "",
      datosPaciente: {
        nombrePaciente: "",
        apellidos: "",
        fechaNacimientoPaciente: "",
        drCabecera: "",
        plan: "",
        clinica: "",
        idPaciente: null,
        embajador: "",
        tipoPaciente: "",
        fechaActual: null,
      },
      datosPlan: {
        plan: {
          plan: "",
          loaderPlan: false,
          vigencia: "",
          logoPlan: null,
        },
        vale: {
          idPacienteVale: null,
          nombreVale: "",
          saldoOriginalVale: null,
          saldoActualVale: null,
          saldoCalculoVale: null,
          descuentoVale: null,
          mostrarSaldo: false
        }
      },
      datosCotizacionFinal: {
        complementosVista: {
          cantidad: null,
          precio: 0,
        },
        totalInversionPti: null,
        totalInversion: null,
        totalRestante: null,
        totalDescuentoPlan: null,
        saldoAFavor: 0,
        totalPagado: null,
        plan: "",
        descripcion: "",
        planExiste: false,
      },
      montoTotalDescuentoCupon: 0,
      saldoOcupado: 0,
      formaPagoSeleccionada: null,
      formaPagoSeleccionada1: null,
      modalFormasPago: false,
      bandera: null,
      msis: [],
      formasPago: [],
      formaPagoTarjeta: [],
      pagosAnteriores: [],
      pagosActuales: [],
      pagosInactivos: [],
      montoAPagar: "",
      ahorroTranferencia: 0,
      totalInversionVista: 0,
      totalSaldo: 0,
      inversionTotalRestante: 0,
      totalGastado: 0,
      restanteActual: null,
      montoFinanciamiento: null,
      financieraSeleccionada: null,
      financieras: [],
      formaPagoFinanciamiento: [],
      formaPagoTransferencia: [],
      guardando: false,
      loadingMax: false,
      saldoBloqueado: false,

      loaderRegresar: false,
      esquemaPago: 1,
      encabezadosTdc: [
        {key: "seleccionado", label: ""},
        {key: "meses", label: "Plazo"},
        {key: "pagoMensual", label: "Pago mensual (aprox)"},
        {key: "costoFinanciamiento", label: "Costo de financiamiento"},
        {key: "total", label: "Total"},
      ],
      encabezadosAtrato: [
        {key: "seleccionado", label: ""},
        {key: "plazo", label: "Plazo"},
        {key: "pagoQuincenal", label: "Pago Quincenal"},
      ],
      registroTablaTdc: [],
      configuracionesMsi: [],
      opcionSeleccionada: null,
      plazosFinancieras: [
        { idPlazo: 1, plazo: "6 pagos semanales" },
        { idPlazo: 2, plazo: "6 pagos quincenales" },
        { idPlazo: 3, plazo: "6 pagos mensuales" },
      ],
      costoFinanciamientoAtrato: [],
      opcionesQuincenas: [],
      plazoFinancieraSeleccionada: null,
      aPlazo: [],
      aPlazoImg: null,
      kueskiPay: [],
      kueskiPayImg: null,
      dentaliaPayImg: null,
      tdcFinanciamiento: false,
      numTdcPlan: 0,
      costoFinanciamientoConIva: 0,
      iva: 0,
      calculoPlazoFijo: false,
      calculoFinancieraAtrato: false,
      retirandoCupon: false,
      modalPlazosAbierto: false
    }
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();
    history.forward();
    if (this.propsReadFromProps) {
      this.idPti = this.propsIdPti;
      this.idSolicitudEtapa = this.propsIdSolicitudEtapa;
      this.idEtapa = this.propsIdEtapa;
      this.idSolicitud = this.propsIdSolicitud;
    } else {
      this.idPti = this.$route.params.idPti;
      this.idSolicitud = this.$route.params.idSolicitud;
      this.idSolicitudEtapa = this.$route.params.idSolicitudEtapa;
      this.idEtapa = this.$route.params.idEtapa;
    }

    this.obtenerDatosTotales();
    console.log(this.datosPaciente, "datos PAciente")
    this.datosPaciente.fechaActual = new Date();

    this.traerMontoMinimoMSI();
    this.obtenerFinancieras();
    this.obtenerConfiguracionPlazos();
    this.obtenerPlazosFinanciamiento();
  },
  methods: {


    traerParametrosPaciente() {
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      return {
        idPti: this.idPti,
        idUsuario: this.$localStorageService.getIdUsuario(),
        horaInicio: inicio,
        horaFin: fin,
        presentacion: true,
        replica: true,
        idSolicitudDiagnostico: this.idSolicitud,
        idClinica: this.$localStorageService.getIdClinica()
      };
    },
    verDisponibilidad() {
      if (this.idSesion === null) {
        this.$swal({
          icon: "error",
          text: "El paciente debe contar con una sesión activa",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
          onClose: () => {
            this.redireccionar('Schedule', true)
          },
        });
      }
    },
    traerFormasPago() {
      const urlFormasPago = this.$api + "catalogos/listaFormas";
      this.$http
          .get(urlFormasPago)
          .then((response) => {
            if (response.data.data) {
              let formas = [];

              response.data.data.forEach((datosForma) => {
                let activado = false;
                if (
                    (this.tipoEvento == false || this.tipoEvento == true) &&
                    datosForma.idFormaPago === 6 &&
                    (this.datosCotizacionFinal.saldoAFavor === 0 ||
                        this.datosCotizacionFinal.saldoAFavor == null)
                ) {
                  activado = true;
                }

                let datos = {
                  idFormaPago: datosForma.idFormaPago,
                  nombreForma: datosForma.nombreForma,
                  activado: activado,
                };
                formas.push(datos);
              });

              //agregamos titulo al metodo de pago
              let tituloPago = {
                idFormaPago: null,
                nombreForma: "Método de pago",
              };
              formas.unshift(tituloPago);
              this.formasPago = formas;
            }
          })
          .catch((error) => {
            this.showErrorMsg(error);
          });
    },
    traerMontoMinimoMSI() {
      const url = this.$api + "forma/msi";
      this.$http
          .get(url)
          .then((response) => {
            if (response.data.data) {
              let monto = [];
              response.data.data.formas.forEach((datosForma) => {
                monto.push(datosForma.montoInicial);
              });
              monto.sort(function (a, b) {
                return a - b;
              });
              this.montoMinimo = monto.slice(0, 1).shift();
            }
          })
          .catch((error) => {
            this.showErrorMsg(error);
          });
    },
    obtenerFinancieras() {
      this.$http.get(this.$api + "financiera/obtener").then((respuesta) => {
        if (respuesta.data.data) {
          this.financieras = respuesta.data.data;

          let titulo = {
            idFinanciera: null,
            financiera: "Financiera",
          };
          this.financieras.unshift(titulo);
        }
      });
    },

    obtenerDatosTotales(){
      const params = {
        idSolicitud: this.idSolicitud,
        idSolicitudFlujo: this.idSolicitudEtapa,
        idEtapa: this.idEtapa,
        idPti: this.idPti,

      }
      this.$http.post(this.$api + "procesoPtiV5/obtenerTotales/metodosPago", params)
          .then((response) => {
            const data = response.data.data;
            this.totalInversionVista = data.inversionTotal;
            this.restanteActual = data.inversionTotalRestante;
            this.idPaciente = data.idPaciente;
          }).finally(() => {
            this.traerFormasPagoVista();
            this.traerFormasPago();
            this.verificarBloqueo();
          });


    },

    /*traerResumenCotizacion() {
      this.datosCotizacionFinal = {
        totalInversion: null,
        totalRestante: null,
        totalDescuentoPlan: null,
        plan: "",
        descripcion: "",
        planExiste: false,
        saldoAFavor: 0,
      };
      const params = {
        idPti: this.idPti,
        opcion: 0,
        fase: 0,
        seguimiento: false
      }

      this.nuevoM2Service
          .obtenerTratamientosAceptadosOpcion(params)
          .then((r) => {
            this.opcionPti = r.opcion;
            this.datosCotizacionFinal.totalInversion = r.inversionTotal;
            this.datosCotizacionFinal.totalDescuentoPlan = r.ahorro;
            this.datosCotizacionFinal.totalDescuentoVale = r.ahorroVale;
            this.datosCotizacionFinal.plan = r.plan;
            this.datosCotizacionFinal.planExiste = r.existePlan;
            // this.plan = r.plan;
            // this.logoPlan = r.logoPlan;
            this.datosCotizacionFinal.saldoAFavor = r.saldoAFavor;
            this.restanteActual = r.totalRestanteAPagar;
            this.etapas = r.etapas;
            this.traerFormasPagoVista();

          })
          .catch((error) => {
            this.showErrorMsg(error);
          })
          .finally(() => {
            this.traerFormasPago();
          });
    },*/
    traerFormasPagoVista() {
      this.totalGastado = 0;
      //obtenemos las formas de pagos que se guardaron (por si se cambia o cierra de pestaña)

      const params = {
        idPti: this.idPti,
        idSolicitud: this.idSolicitud,
        idEtapa: this.idEtapa
      }

      const url = this.$api + "forma/vista/activav5";
      this.$http
          .post(url, params)
          .then((response) => {
            this.traerMontosSiExisteCupon();
            response.data.data.forEach((i) => {
              //Inversión total restante  lo que falta por pagar
              this.restanteActual = parseInt(this.restanteActual) - i.monto;
              //suma de las formas de pago
              this.totalGastado = parseInt(this.totalGastado) + i.monto;
              this.codigo = i.codigo;
            });
            this.totalGastado = this.totalGastado - this.montoTotalDescuentoCupon;
            //tabla formas de pago
            this.pagosAnteriores = response.data.data;

            if (this.propsReadFromProps != null && this.propsReadFromProps) {
              const numPagsAnteriores = this.pagosAnteriores.length;
              for (let index=0; index<numPagsAnteriores; index++) {
                this.cancelarFormaVista(0);
              }
            } else {
              if (this.pagosAnteriores.length > 0) {
                this.$bvToast.toast('Cuenta con pagos anteriores, por favor revíselos en el botón con movimiento.', {
                  title: 'Aviso',
                  noAutoHide: false,
                  variant: 'primary',
                  solid: true
                })
              }
            }
          })
          .catch((err) => {
            this.showErrorMsg(err);
          });
    },

    abrirModalEditar(){
      if(this.montoTotalDescuentoCupon > 0){
        this.$swal({
          icon: "warning",
          showCancelButton: true,
          title: "La información del pago va a cambiar",
          text: "Si modifica la información del método de pago, se eliminará la herramienta de cierre, ¿desea continuar?",
          confirmButtonText: "Sí, continuar",
          confirmButtonColor: "#FFC300",
          cancelButtonText: "No, cancelar",
          cancelButtonColor: "#7B7D7D"
        }).then((result) =>{
          if(result.isConfirmed){
            this.quitarCodigo();

            this.modalEditFormasPago = true;
            this.clickBotonEdit = true;
            this.codigo = "";
            this.mostrarMensaje = false;
            this.mensajeError = "";
          }else{
            return;
          }
        });
      }else{
        this.modalEditFormasPago = true;
        this.clickBotonEdit = true;
      }
    },
    calcularDescuento(registroPago) {
      if (
          this.pagosActuales[registroPago].porcentaje >
          this.pagosActuales[registroPago].porcentajeMaximo
      ) {
        this.$swal({
          icon: "error",
          text: "Porcentaje fuera de rango",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      } else {
        const montoDescuento =
            (this.pagosActuales[registroPago].monto *
                this.pagosActuales[registroPago].porcentaje) /
            100;

        this.pagosActuales[registroPago].cambiarPorcentaje = false;
        this.pagosActuales[registroPago].montoPagar =
            this.pagosActuales[registroPago].monto - montoDescuento;
        this.pagosActuales[registroPago].ahorro = montoDescuento;
      }
    },
    cancelarForma(forma) {
      if (this.montoTotalDescuentoCupon > 0) {
        this.$swal.fire({
          icon: "warning",
          showCancelButton: true,
          title: "La información del pago va a cambiar",
          text: "Si modifica la información del método de pago, se eliminará la herramienta de cierre, ¿desea continuar?",
          confirmButtonText: "Sí, continuar",
          confirmButtonColor: "#FFC300",
          cancelButtonText: "No, cancelar",
          cancelButtonColor: "#7B7D7D"
        }).then((result) => {
          if (result.isConfirmed) {
            this.quitarCodigo();

            this.cupon = [];
            this.herramientaCierre = [];
            this.mostrarMensaje = false;
            this.mensajeError = "";
            this.codigo = null;


            if (forma.idFormaPago == 2) {
              this.formaPagoTarjeta.forEach((i, j) => {
                if (i.posicion === forma.posicion) {
                  this.formaPagoTarjeta.splice(j, 1);
                }
              });
            } else if (forma.idFormaPago == 7) {
              this.formaPagoFinanciamiento.forEach((i, j) => {
                if (i.posicion === forma.posicion) {
                  this.formaPagoFinanciamiento.splice(j, 1);
                }
              });
            } else {
              this.formaPagoTransferencia.forEach((i, j) => {
                if (i.posicion === forma.posicion) {
                  this.formaPagoTransferencia.splice(j, 1);
                }

                if (forma.descuentoAplicado) {
                  this.ahorroTranferencia -= forma.ahorro;
                }
              });
            }
            this.pagosActuales.forEach((i, j) => {
              //modificado por adrian
              //importante, si se deja como esta lo toma como string y lo junta como texto y no suma
              var monto = parseInt(forma.monto);
              if (i.posicion === forma.posicion && i.idFormaPago === 6) {
                this.datosCotizacionFinal.saldoAFavor += monto;
                this.saldoOcupado -= monto;
                //this.totalGastado -= forma.monto; //cambio adrian
              }
              if (i.posicion === forma.posicion) {
                //GUARDADOOOOO
                this.restanteActual += monto;
                this.totalGastado -= monto;
                this.pagosActuales.splice(j, 1);
              }
            });
          }
        });
      } else {
        if (forma.idFormaPago == 2) {
          let nTDCPlan = 0;
          this.formaPagoTarjeta.forEach((i, j) => {
            if (i.posicion === forma.posicion) {
              this.formaPagoTarjeta.splice(j, 1);
              if(i.plazoFijo){
                this.costoFinanciamientoConIva -= i.costoFinanciamiento;
                nTDCPlan = nTDCPlan + 1;
                this.numTdcPlan = this.numTdcPlan - 1;
              }
            }
          });
          if(this.numTdcPlan == nTDCPlan-1){
            this.tdcFinanciamiento = false;
          }
        } else if (forma.idFormaPago == 7) {
          this.formaPagoFinanciamiento.forEach((i, j) => {
            if (i.posicion === forma.posicion) {
              this.formaPagoFinanciamiento.splice(j, 1);
            }
          });
        } else {
          this.formaPagoTransferencia.forEach((i, j) => {
            if (i.posicion === forma.posicion) {
              this.formaPagoTransferencia.splice(j, 1);
            }

            if (forma.descuentoAplicado) {
              this.ahorroTranferencia -= forma.ahorro;
            }
          });
        }
        this.pagosActuales.forEach((i, j) => {
          //modificado por adrian
          //importante, si se deja como esta lo toma como string y lo junta como texto y no suma
          var monto = parseInt(forma.monto);
          if (i.posicion === forma.posicion && i.idFormaPago === 6) {
            this.datosCotizacionFinal.saldoAFavor += monto;
            this.saldoOcupado -= monto;
            //this.totalGastado -= forma.monto; //cambio adrian
          }
          if (i.posicion === forma.posicion) {
            //GUARDADOOOOO
            this.restanteActual += monto;
            this.totalGastado -= monto;
            this.pagosActuales.splice(j, 1);
          }
        });
      }
    },
    buscarDescuento(registroPago) {
      this.pagosActuales[registroPago].cargando = true;
      const montoPagado = this.pagosActuales[registroPago].monto;
      const formaPago = this.pagosActuales[registroPago].idFormaPago;
      const urlDescuento = this.$api + "diagnostico/obtener/descuento-monto";
      const parametros = {
        idFormaPago: formaPago,
        monto: montoPagado,
      };

      this.$http
          .post(urlDescuento, parametros)
          .then((response) => {
            if (response.data) {
              this.pagosActuales[registroPago].cargando = false;
              this.pagosActuales[registroPago].descuentoAplicado = true;
              this.pagosActuales[registroPago].porcentajeMaximo =
                  response.data.data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    cancelarFormaVista(index) {
      //inversion de las replicas aceptadas lo que falta por pagar ) Inversión total restante:
      this.restanteActual += this.pagosAnteriores[index].monto;

      //modificaicon adrian
      //importante para los saldos a favor
      if (this.pagosAnteriores[index].idFormaPago == 6) {
        this.totalSaldo += this.pagosAnteriores[index].monto;
      }
      //Total pagado:
      this.totalGastado -= this.pagosAnteriores[index].monto;
      this.pagosInactivos.push(this.pagosAnteriores[index]);
      this.pagosAnteriores.splice(index, 1);
    },

    activarModal() {

      if ((this.pagosActuales.length > 1 && this.pagosAnteriores.length < 1)
          || (this.pagosAnteriores.length > 1 && this.pagosActuales.length < 1)
          || (this.pagosAnteriores.length > 0 && this.pagosActuales.length > 0)) {
        this.validacionesCupon = [];
        this.$swal.fire({
          icon: "error",
          html: '<strong><span>Solo se puede ingresar un metodo de pago</span></strong> <br>' +
              ' <br> <h5 style="font-size: 11px;margin-bottom: -20px;"> Los cupones de cierre solo funcionan con un ' +
              'método de pago. Deberás de escoger uno </h5> <br>',
          cancelButtonText: "Enterado",
          showCancelButton: true,
          showConfirmButton: false,
          closeOnClickOutside: false,
          allowOutsideClick: false,
        })
        return;
      }
      if (this.formaPagoTransferencia.length == 0
          && this.formaPagoFinanciamiento.length == 0
          && this.formaPagoTarjeta.length == 0
          && this.pagosAnteriores.length == 0) {
        this.$swal({
          icon: "error",
          title: "Ingrese al menos un método de pago",
          text: "Debe ingresar al menos un método de pago para poder redimir un cupón",
          confirmButtonText: "Enterado",
          confirmButtonColor: "#7B7D7D",
        });
        this.modalHerramientasCierre = false;
        return;
      }

      if (this.montoTotalDescuentoCupon > 0) {
        this.$swal({
          icon: "warning",
          showCancelButton: true,
          title: "La información del pago va a cambiar",
          text: "Si modifica la información del método de pago, se eliminará la herramienta de cierre, ¿desea continuar?",
          confirmButtonText: "Sí, continuar",
          confirmButtonColor: "#FFC300",
          cancelButtonText: "No, cancelar",
          cancelButtonColor: "#7B7D7D"
        }).then((result) => {
          if (result.isConfirmed) {
            if (result.isConfirmed) {
              this.quitarCodigo();

              this.codigo = "";
              this.mostrarMensaje = false;
              this.mensajeError = "";
              return;
            }


          } else {
            return;
          }
        });

        this.modalHerramientasCierre = false;
        return;
      }


      this.modalHerramientasCierre = true;
    },
    quitarCodigo() {
      this.retirandoCupon = true;
      if (this.montoTotalDescuentoCupon > 0) {
        this.restanteActual += this.montoTotalDescuentoCupon;
        this.$http.post(this.$api + "forma/retiraCuponesDistribucion?idPti=" + this.idPti + "&idCupon=" + this.idCupon)
            .then((response) => {
              console.info(response)


              this.codigo = "";
              this.mostrarMensaje = false;
              this.validacionesCupon = [];
              this.modalHerramientasCierre = false;

              this.traerMontosSiExisteCupon();
            })
      } else {

        this.limpiarCupon()
        this.traerMontosSiExisteCupon();
      }
    },
    cancelar(){
      this.modalHerramientasCierre = false;
      //  this.quitarCodigo()
    },
    traerMontosSiExisteCupon() {
      const params = {
        idPti: this.idPti,
        idSolicitud: this.idSolicitud,
        idSolicitudEtapa: this.idSolicitudEtapa,
        edicion: this.idEtapa == 98 ? true : false
      }
      this.$http.post(this.$api + "forma/obtener/totalesInversion", params)
          .then((response) => {
            let montos = response.data.data;
            console.log("montos",montos)
            if (montos.cupon !== null && montos.idCupon !== null) {


              this.idCupon = montos.idCupon;
              this.validacionesCupon.idCupon = montos.idCupon
              this.cupon = montos.cupon
              this.validacionesCupon.tipoDescuento = montos.tipoDescuento;
              this.validacionesCupon.cantidadDescuento = montos.descuento;
              // this.totalInversionVista = montos.inversionTotal;
              this.validacionesCupon.msjExito = montos.idCupon !== null ? true : false;

              console.log("this.totalGastado",this.totalGastado)
              if (this.pagosAnteriores.length <= 0 && montos.idCupon === null) {
                this.montoTotalDescuentoCupon = montos.montoAhorradoCupon;
                this.restanteActual = montos.inversionTotal - montos.montoAhorradoCupon - this.totalGastado;

              } else {
                this.montoTotalDescuentoCupon = montos.montoAhorradoCupon;
                this.datosCotizacionFinal.totalInversion = montos.inversionTotal;
                this.inversionTotalRestante = montos.inversionTotal - montos.montoAhorradoCupon - this.totalGastado;
                this.totalGastado = montos.formaPagoTemporal === null ? this.totalGastado : montos.formaPagoTemporal;
                this.restanteActual = montos.inversionTotal - montos.montoAhorradoCupon - this.totalGastado;


                if (this.inversionTotalRestante < 0) {
                  this.inversionTotalRestante = 0
                  this.datosCotizacionFinal.totalInversion = montos.inversionTotal - montos.montoAhorradoCupon;

                  this.pagosActuales.forEach(p => {
                    p.monto = montos.formaPagoTemporal;
                    p.montoPagar = montos.formaPagoTemporal;

                  })
                }
              }
            }else {
              if (this.validacionesCupon.idCupon !== null) {


                if (!this.retirandoCupon){
                  this.$bvToast.toast("Por favor revise que sus tratamientos no tengan una promoción ", {
                    title: 'No se aplicó el cupón',
                    variant: 'success',
                    solid: false
                  })
                }


                this.codigo = "";
                this.montoTotalDescuentoCupon = 0;
                this.mostrarMensaje = false;
                this.validacionesCupon = {
                  idCupon: null,
                  cantidadDescuento: 0,
                  tipoDescuento: null,
                  tipoAplicacionDescuento: null,
                  msjExito: null,
                },
                    this.modalHerramientasCierre = false;
              }
            }
          })
    },
    limpiarCupon() {
      this.codigo = null;
      this.validacionesCupon = [];
    },
    validarCodigo(){

      if(this.formaPagoTransferencia.length == 0
          && this.formaPagoFinanciamiento.length == 0
          && this.formaPagoTarjeta.length == 0
          && this.pagosAnteriores.length == 0){
        this.$swal({
          icon: "error",
          title: "Ingrese al menos un método de pago",
          text: "Debe ingresar al menos un método de pago para poder redimir un cupón",
          confirmButtonText: "Enterado",
          confirmButtonColor: "#7B7D7D",
        });
        this.modalHerramientasCierre = false;
        return;
      }


      if ( (this.pagosActuales.length > 1 && this.pagosAnteriores.length < 1 )
          || (this.pagosAnteriores.length > 1 && this.pagosActuales.length < 1)
          || (this.pagosAnteriores.length > 0 && this.pagosActuales.length > 0 )
      ){
        this.$swal({
          icon: "error",
          title: "Solo se puede ingresar un método de pago",
          text: "Los cupones de cierre solo funcionan con un método de pago. Deberás escoger uno.",
          confirmButtonText: "Enterado",
          confirmButtonColor: "#7B7D7D",
        })
        this.modalHerramientasCierre = false;
        return;
      }

      let idFormaP = null;
      let idFinanciera = null;
      let montoPagar = null;

      if (this.pagosActuales.length > 0){
        idFormaP = this.pagosActuales[0].idFormaPago
        idFinanciera = this.pagosActuales[0].idFinanciera
        montoPagar = this.pagosActuales[0].montoPagar
      }

      else if(this.pagosAnteriores.length > 0){
        idFormaP = this.pagosAnteriores[0].idFormaPago
        idFinanciera = this.pagosActuales[0].idFinanciera
        montoPagar = this.pagosAnteriores[0].montoPagar

      }

      const datos = {
        idFormaPago: idFormaP,
        idFinanciera: idFinanciera,
        msi: this.idMeses,
        inversionTotalPti: this.totalInversionVista,
        montoPagar: montoPagar,
        idPti: this.idPti,
        idPaciente: this.idPaciente,
        codigo: this.codigo,
      }


      this.cuponesService.obtenerHerramienta(  datos).then((response) => {
        this.validacionesCupon = response.data;

        if (this.validacionesCupon.mjsExito){
          this.idCupon = this.validacionesCupon.idCupon;
        }

      })
    },
    aplicarCodigo(){
      this.modalHerramientasCierre = false;

      let datos = {
        idCupon: this.validacionesCupon.idCupon,
        idPaciente: this.idPaciente,
        idPti: this.idPti,
        descuentoCupon: this.validacionesCupon.cantidadDescuento,
        tipoDescuento: this.validacionesCupon.tipoDescuento,
        idSolicitud: this.idSolicitud,
        idSolicitudEtapa: this.idSolicitudEtapa,
        tipoAplicacionDescuento: this.validacionesCupon.tipoAplicacionDescuento,
        edicion: this.idEtapa == 98 ? true : false
      }

      this.$http.post(this.$api + "forma/guardar/tratamientoCupon", datos )
          .then((response) => {
            if (response.data.data){
              this.distribuirMontos(true);
            }

          })

    },
    async distribuirMontos(guardarDeFuncionCupun) {
      this.enviando = true;

      let exito = true;

      this.pagosAnteriores.forEach((p) => {
        if (
            (p.idFormaPago == 2 && p.plazo === "Sin plazo") ||
            (p.idFormaPago == 7 && p.plazo === "Sin plazo")
        ) {
          this.$swal({
            icon: "warning",
            text: "Tiene una forma de pago anterior 'Sin Plazo', debe agregar los datos correctamente",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });

          exito = false;
        }
      });

      if (this.validarFormasPagoExistentes()) {
        let formasVista = [];

        this.formaPagoTarjeta.forEach((i) => {
          let tarjeta = {
            formaPagoNombre: i.formaPagoNombre,
            montoPagar: i.montoPagar,
            tipo: 1,
            meses: i.plazo,
            costoFinanciamiento: i.costoFinanciamiento
          };
          formasVista.push(tarjeta);
        });

        this.formaPagoFinanciamiento.forEach((i) => {
          let fin = {
            formaPagoNombre: i.formaPagoNombre,
            montoPagar: i.montoPagar,
            tipo: 3,
          };
          formasVista.push(fin);
        });

        this.formaPagoTransferencia.forEach((i) => {
          let tra = {
            formaPagoNombre: i.formaPagoNombre,
            montoPagar: i.montoPagar,
            tipo: 2,
          };
          formasVista.push(tra);
        });

        let listaAnteriores = [];
        this.pagosInactivos.forEach((i) => {
          listaAnteriores.push(i.idPtiForma);
        });
        this.pagosAnteriores.forEach(pa => {
          formasVista.push(pa);
        });

        if (exito) {
          let parametros = {
            vistaPagos: formasVista,
            vistaPagosAnterior: listaAnteriores,
            distribucion: this.pagosActuales,
            ahorroTransferencia: this.ahorroTranferencia,
            idPti: this.idPti,
            usuarioLogeado: this.$localStorageService.getIdUsuario(),
            replica: this.evento == 1 ? true : false,
            idCupon: this.validacionesCupon.idCupon,
            idSolicitudEtapa: this.$route.params.idSolicitudEtapa,
            idSolicitud: this.$route.params.idSolicitud,
            idSesion: this.idSesion,
            cupon: false
          };

          if(this.validacionesCupon.msjExito && guardarDeFuncionCupun) {
            await this.enviarMontosPorCupon(parametros)
          } else {
            await this.enviarMontos(parametros);
          }
        } else {
          this.enviando = false;
        }
      } else {
        this.$swal({
          icon: "error",
          text: "Se debe seleccionar al menos una forma de pago",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        this.enviando = false;
      }
    },
    async enviarMontosPorCupon(parametros) {
      parametros.cupon = true;
      parametros.idSolicitudEtapa = this.idSolicitudEtapa
      const url =
          this.$api + "forma/temporal";

      await this.$http
          .post(url, parametros)
          .then((response) => {
            console.info(response)
            this.traerMontosSiExisteCupon();
          }).finally(()=>this.enviando = false);
    },
    async enviarMontos(parametros) {
      this.loadingMax = true;
      parametros.idSolicitudEtapa = this.idSolicitudEtapa
      this.enviando = true;
      const url =
          this.$api + "forma/temporal";
      this.$http
          .post(url, parametros)
          .then(async (response) => {
            if (response.status === 200) {
              this.guardarResumenPti();
              if (this.totalGastado == 0) {

                await this.nuevoM2Service.guardarDistribucionesPagoCero(this.idPti).then(async (r) => {
                  console.debug(r)
                  this.enviando = false;

                  if (this.propsReadFromProps) {
                    await this.redireccionarCAJA();
                  } else {
                    await this.redireccionar("ImpresionPtiNuevoM2PagoCero", false);
                  }

                });
              }

            }
          })
          .catch((err) => {
            this.enviando = false;
            this.loadingMax = false;
            this.showErrorEnvio(err);
          }).finally(()=>this.enviando = false);
    },

    async guardarResumenPti() {
      const url = this.$api + "diagnostico/guardar/resumen-cotizacion";
      await this.$http
          .post(url, this.traerDatosResumenPti())
          .then((response) => {
            if (response.status === 200 && this.totalGastado > 0) {
              this.pasarDistribucion(0);
            }
          })
          .catch((error) => {
            this.showErrorEnvio(error);
          }).finally(() => {
            this.loadingMax = false
          });
    },
    traerDatosResumenPti() {
      let formasPago = [];
      this.pagosActuales.forEach((fSesion) => {
        let pagos = {
          idFormaPago: fSesion.idFormaPago,
          montoPagar: fSesion.montoPagar,
        };

        formasPago.push(pagos);
      });

      return {
        ahorroPlan: this.datosCotizacionFinal.totalDescuentoPlan,
        ptiContratado: 1,
        descripcion: this.datosCotizacionFinal.descripcion,
        idClinica: this.$localStorageService.getIdClinica(),
        idEmpleado: this.$localStorageService.getIdEmpleado(),
        idPti: this.idPti,
        inversionTotal: this.datosCotizacionFinal.totalInversion,
        inversionRestante: this.restanteActual,
        pagos: formasPago,
        totalPti: this.totalPti,
      };
    },
    pasarDistribucion() {
      this.loadingMax = false;
      this.$swal({
        icon: "success",
        text: "Se ha guardado la cotización correctamente",
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
        onClose: () => {
          this.redireccionar("distribucionPagoPTIv5", false);
        },
      });
    },
    redireccionar(ruta, forzarRedireccionar) {
      if (this.propsReadFromProps && !forzarRedireccionar) {
        this.$emit("cambiarEtapaWizzardCaja", 2);
      } else {

        let paramsRutaRedir = undefined;

        switch (ruta) {
          case 'bandejaEmbajadorHallazgoTabs': {
            paramsRutaRedir = {tab: 3};
            break;
          }
          case 'DistribucionCobroPTIReplicas': {
            paramsRutaRedir = {
              idPti: this.idPti,
              idSolicitudEtapa: this.idSolicitudEtapa,
              idTicket: this.idTicket,
              idEtapa: this.idEtapa,
              replica: 1,
            };
            break;
          }
          case 'ImpresionPtiNuevoM2PagoCero': {
            paramsRutaRedir = {
              idPti: this.idPti,
              idSolicitud: this.idSolicitudEtapa,
              opcion: this.opcionPti
            };
            break;
          }
          case 'distribucionPagoPTIv5': {
            paramsRutaRedir = {
              iidPti: this.idPti,
              idSolicitudEtapa: this.idSolicitudEtapa,
              idSolicitud: this.idSolicitud,
              idEtapa: this.idEtapa == 98 ? 99 : 91,
              opcion: this.$route.params.opcion
            };
            break;
          }
        }

        if (ruta != null) {
          this.$router.push({
            name: ruta,
            params: paramsRutaRedir
          }).catch((err) => {
            this.showErrorEnvio(err);
          });
        }
      }
    },

    abiriModalPago() {

      if (this.montoTotalDescuentoCupon > 0) {
        this.$swal({
          icon: "warning",
          showCancelButton: true,
          title: "La información del pago va a cambiar",
          text: "Si modifica la información del método de pago, se eliminará la herramienta de cierre, ¿desea continuar?",
          confirmButtonText: "Sí, continuar",
          confirmButtonColor: "#FFC300",
          cancelButtonText: "No, cancelar",
          cancelButtonColor: "#7B7D7D"
        }).then((result) => {
          if (result.isConfirmed) {
            if (result.isConfirmed) {
              this.quitarCodigo();

              this.modalFormasPago = true;
              this.codigo = "";
              this.mostrarMensaje = false;
              this.mensajeError = "";
            }


          } else {
            return;
          }
        });
      } else {

        this.modalFormasPago = true
      }
    },
    limpiarDatosMetodo(){
      this.opcionSeleccionada = null;
      this.registroTablaTdc = [];
      this.financieraSeleccionada = null;
      this.costoFinanciamientoAtrato = [];
      this.plazoFinancieraSeleccionada = null;
      this.montoAPagar = ""
      this.calculoPlazoFijo = false;
      this.calculoFinancieraAtrato = false;
    },
    async calcularMonto() {
      if (this.montoAPagar == 0 && this.formaPagoSeleccionada == 1){
        await this.$swal({
          icon: "error",
          text: "Por favor agrega un método de pago con monto mayor a cero.",
          confirmButtonText: "Cerrar",
          confirmButtonColor: "#d3d4d5",
        });
      } else {
        if ((this.esquemaPago === 2 && this.formaPagoSeleccionada === 2 && this.opcionSeleccionada == null) || (this.formaPagoSeleccionada === 7 && this.financieraSeleccionada === 2 && this.opcionSeleccionada == null)){
          await this.$swal({
            icon: "error",
            text: "Por favor selecciona una opción de la tabla.",
            confirmButtonText: "Cerrar",
            confirmButtonColor: "#d3d4d5",
          });
          return;
        }

        if (this.formaPagoSeleccionada === 7 && this.plazoFinancieraSeleccionada == null && this.financieraSeleccionada !== 2){
          await this.$swal({
            icon: "error",
            text: "Por favor selecciona un plazo.",
            confirmButtonText: "Cerrar",
            confirmButtonColor: "#d3d4d5",
          });
          return;
        }

        this.guardando = true;
        let error = false;
        let opcion = 0;
        let restante = parseInt(this.restanteActual) - parseInt(this.montoAPagar);
        const gastado = Number(this.montoAPagar);




        if (this.montoAPagar < 0) {
          this.mostrarErrores(opcion);
          this.totalGastado -= gastado;
        } else {
          //modificado por adrian
          //importante, si se deja como esta lo toma como string y lo junta como texto y no suma
          this.totalGastado += parseInt(gastado);

          //modificado por adrian
          if (restante < 0) {
            error = true;
            opcion = 4;
          }

          this.pagosActuales.forEach((i) => {
            if (
                this.formaPagoSeleccionada == 7 &&
                this.montoFinanciamiento > this.montoAPagar
            ) {
              error = true;
              opcion = 1;
            }

            if (
                this.formaPagoSeleccionada === 1 &&
                i.idFormaPago == this.formaPagoSeleccionada
            ) {
              error = true;
              opcion = 2;
            }

            if (
                this.formaPagoSeleccionada === 7 &&
                i.idFormaPago == this.formaPagoSeleccionada
            ) {
              error = true;
              opcion = 3;
            }
          });

          if (this.formaPagoSeleccionada === 2) {
            this.bandera = true;
          }
          if (this.validarFormasNuevas()) {
            error = true;
            opcion = 5;
          }

          //modificado pro adrian
          if (this.formaPagoSeleccionada === 6) {
            if (restante < 0) {
              error = true; //modificado por adrian
              opcion = 4;
            } else {
              if (this.formaPagoSeleccionada === 6) {
                error = this.aplicarSaldo();
                opcion = 6;
              }
            }
          }

          if (this.formaPagoSeleccionada === 7) {
            if (this.financieraSeleccionada === null) {
              error = true;
              opcion = 7;
            }
          }
          if (
              this.montoAPagar >= 0 &&
              this.montoAPagar !== "" &&
              this.formaPagoSeleccionada &&
              !error
          ) {
            await this.agregarFormaPagoValido(restante);
            this.guardando = false;
          } else {
            this.mostrarErrores(opcion);
            this.totalGastado -= gastado;
            return;
          }
        }
        this.guardando = false;
        this.cerrarModalFormas();
      }
    },
    async agregarFormaPagoValido(restante) {
      this.pago = true;
      this.restanteActual = restante;

      //sacamos el nombre de la forma de pago
      let nombreForma = "";
      this.formasPago.forEach((seleccionFormaPago) => {
        if (seleccionFormaPago.idFormaPago == this.formaPagoSeleccionada) {
          nombreForma = seleccionFormaPago.nombreForma;
        }
      });

      //anadimos a un array para la tabla
      let maneraPago = null;
      //1-Contado 2-planes
      if(this.esquemaPago == 1){
        maneraPago = {
          idFormaPago: this.formaPagoSeleccionada,
          formaPagoNombre: nombreForma,
          monto: this.montoAPagar,
          montoPagar: this.montoAPagar,
          ahorro: 0,
          porcentaje: 0,
          porcentajeMaximo: 0,
          restante: restante,
          descuentoAplicado: false,
          idFormaDetalle: null,
          plazo: "",
          montoDesglosado: 0,
          posicion: this.pagosActuales.length,
          cambiarPorcentaje: false,
          cargando: false,
          idFinanciera: null,
          plazoNum: null,
          plazoFijo: false,
          tieneMsi: false,
        };
      }else{
        //2-tdc 7-financiamiento
        if(this.formaPagoSeleccionada === 2){
          if(this.opcionSeleccionada.costoFinanciamiento != 'Sin costo'){
            this.tdcFinanciamiento = true;
            this.numTdcPlan++;
            this.costoFinanciamientoConIva += this.opcionSeleccionada.costoFinanciamiento;
          }
          maneraPago = {
            idFormaPago: this.formaPagoSeleccionada,
            formaPagoNombre: nombreForma,
            monto: this.montoAPagar,
            montoPagar: this.montoAPagar,
            ahorro: 0,
            porcentaje: 0,
            porcentajeMaximo: 0,
            restante: restante,
            descuentoAplicado: false,
            idFormaDetalle: null,
            montoDesglosado: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? this.opcionSeleccionada.pagoMensual : 0,
            posicion: this.pagosActuales.length,
            cambiarPorcentaje: false,
            cargando: false,
            plazoNum: this.opcionSeleccionada.meses,
            idFinanciera: null,
            plazo: null,
            meses: this.opcionSeleccionada.meses,
            total: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? this.montoAPagar : this.opcionSeleccionada.total,
            plazoFijo: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? false : true,
            tieneMsi: this.opcionSeleccionada.costoFinanciamiento != 'Sin costo' ? false : true,
            pagoMensual: this.opcionSeleccionada.pagoMensual,
            costoFinanciamiento: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? 0 : this.opcionSeleccionada.costoFinanciamiento,
            montoFinanciamiento: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? 0 : this.opcionSeleccionada.montoFinanciamiento,
            iva: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? 0 : this.opcionSeleccionada.iva,
          };
        }else{
          maneraPago = {
            idFormaPago: this.formaPagoSeleccionada,
            formaPagoNombre: nombreForma,
            monto: this.montoAPagar,
            montoPagar: this.montoAPagar,
            ahorro: 0,
            porcentaje: 0,
            porcentajeMaximo: 0,
            restante: restante,
            descuentoAplicado: false,
            idFormaDetalle: null,
            montoDesglosado: 0,
            posicion: this.pagosActuales.length,
            cambiarPorcentaje: false,
            cargando: false,
            plazoNum: this.financieraSeleccionada == 2 ? this.opcionSeleccionada.plazo  : this.plazoFinancieraSeleccionada,
            idFinanciera: this.financieraSeleccionada,
            plazo: this.financieraSeleccionada == 2 ? this.opcionSeleccionada.plazo  : this.plazoFinancieraSeleccionada,
            plazoFijo: false,
            tieneMsi: false,
          };
        }
        
      }
      
      this.pagosActuales.push(maneraPago);
      this.formaPagoSeleccionada1 = this.formaPagoSeleccionada;
      //aplicamos las formas de pago para cada ventanita
      await this.formasPagoIndividuales(
          nombreForma,
          this.montoAPagar,
          this.pagosActuales.length - 1
      );

      if (this.formaPagoSeleccionada === 7) {
        await this.obtenerMeses();
      }

      this.montoAPagar = "";
    },
    validarFormasPagoExistentes() {
      if (this.propsReadFromProps && this.pagosActuales.length === 0) {
        return false;
      }

      let valida = false;
      if (this.pagosActuales.length != 0 || this.pagosAnteriores.length != 0) {
        valida = true;
      }

      return valida;
    },
    obtenerMeses() {
      const params = {
        monto: this.montoAPagar,
        idFinanciera: this.financieraSeleccionada
      }
      this.$http
          .post(
              this.$api +
              "forma/listar/meses", params)
          .then((res) => {
            if (res.data.data) {
              const msiFin = res.data.data;

              if (this.pago.msi != null && !msiFin.includes(this.pago.msi)) {
                this.pago.msi = null;
              }

              this.msis = this.$global.msi();

              if (msiFin.length > 0) {
                this.msis = this.msis.filter((value) =>
                    msiFin.includes(value.value)
                );
              }
              this.msis = msiFin;
            }
          });
    },
    async formasPagoIndividuales(nombreForma, aPagar, posicion) {
      const parametros = {monto: this.montoAPagar}

      const urlFormasPago =
          this.$api +
          "forma/catalogo/listaFormasDetalle"


      try {
        await this.$http
            .post(urlFormasPago, parametros)
            .then((response) => {
              if (response.data.data) {
                let listaMsi = [];

                if (response.data.data.msi) {
                  listaMsi = response.data.data.msi;
                }

                let listaFin = [];
                if (response.data.data.financiamiento) {
                  let tituloPago = {
                    idFormaPagoDetalle: null,
                    detalleForma: "FINANCIAMIENTO",
                  };
                  response.data.data.financiamiento.unshift(tituloPago);
                  listaFin = response.data.data.financiamiento;
                }

                //agregamos msi
                if (this.formaPagoSeleccionada1 === 2) {
                  if(this.esquemaPago == 1){
                    this.formaPagoTarjeta.push({
                      msi: null,
                      msiLista: listaMsi,
                      formaPagoNombre: nombreForma,
                      montoPagar: aPagar,
                      posicion: posicion,
                      plazo: "",
                      plazoFijo: false,
                      tieneMsi: false,
                    });
                  }else{
                    this.formaPagoTarjeta.push({
                      msi: null,
                      msiLista: listaMsi,
                      formaPagoNombre: nombreForma,
                      montoPagar: aPagar,
                      posicion: posicion,
                      plazo: this.opcionSeleccionada.meses,
                      total: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? aPagar : this.opcionSeleccionada.total,
                      plazoFijo: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? false : true,
                      tieneMsi: this.opcionSeleccionada.costoFinanciamiento != 'Sin costo' ? false : true,
                      pagoMensual: this.opcionSeleccionada.pagoMensual,
                      costoFinanciamiento: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? 0 : this.opcionSeleccionada.costoFinanciamiento,
                      montoFinanciamiento: this.opcionSeleccionada.costoFinanciamiento == 'Sin costo' ? 0 : this.opcionSeleccionada.montoFinanciamiento,
                      iva: this.opcionSeleccionada.iva == 'Sin costo' ? 0 : this.opcionSeleccionada.iva
                    });
                  }
                } else if (this.formaPagoSeleccionada1 === 7) {
                  this.formaPagoFinanciamiento.push({
                    fin: null,
                    finLista: listaFin,
                    formaPagoNombre: nombreForma,
                    montoPagar: aPagar,
                    posicion: posicion,
                    idFinanciera: this.financieraSeleccionada,
                    plazo: this.financieraSeleccionada == 2 ? this.opcionSeleccionada.plazo  : this.plazoFinancieraSeleccionada,
                  });
                } else {
                  this.formaPagoTransferencia.push({
                    formaPagoNombre: nombreForma,
                    montoPagar: aPagar,
                    posicion: posicion,
                  });
                }
              }
            })
            .catch((error) => {
              this.guardando = false;
              this.showErrorMsg(error);
            })
            .finally(() => this.guardando = false);
      } catch (e) {
        this.guardando = false;
      }
    },
    aplicarSaldo() {
      let error = false;
      if (this.montoAPagar > this.datosCotizacionFinal.saldoAFavor) {
        error = true;
      } else {
        this.datosCotizacionFinal.saldoAFavor -= parseInt(this.montoAPagar);
        this.saldoOcupado += parseInt(this.montoAPagar);
      }

      return error;
    },
    validarFormasNuevas() {
      let error = false;
      this.pagosAnteriores.forEach((i) => {
        if (
            this.formaPagoSeleccionada === 1 &&
            i.idFormaPago == this.formaPagoSeleccionada
        ) {
          error = true;
        }

        if (
            this.formaPagoSeleccionada === 7 &&
            i.idFormaPago == this.formaPagoSeleccionada
        ) {
          error = true;
        }
      });

      return error;
    },


    regresarNegociar(){
      if(this.validacionesCupon.idCupon !== null || this.montoTotalDescuentoCupon > 0){
        this.$swal({
          icon: "error",
          text: "Agrego un cupón, debe retirarlo para poder regresar a Negociar",
          confirmButtonText: "De acuerdo",
          confirmButtonColor: "#0e6ba9",
        });
      }else{
        this.loaderRegresar = true;
        const envio = {
          idSolicitud: this.idSolicitud,
          idPti: this.idPti,
          idSolicitudEtapa: this.idSolicitudEtapa,
          idEtapa: this.idEtapa
        }
        this.$http.post(this.$api +
            "procesoPtiV5/regresarANegociar", envio
        )
            .then((response) => {
              if (this.idEtapa == 98){

                this.$router.push({
                  name: "resumenInversion",
                  params: {
                    idPti: this.idPti,
                    idSolicitudEtapa: response.data.data,
                    idSolicitud: this.idSolicitud,
                    idEtapa: 97
                  }})

              }else{
                this.$router.push({
                  name: "resumenInversion",
                  params: {
                    idPti: this.idPti,
                    idSolicitudEtapa: response.data.data,
                    idSolicitud: this.idSolicitud,
                    idEtapa: 89
                  }})
              }
              this.inactivarConfiguracionPlazosPti();
              this.loaderRegresar = false;
            })

      }
    },
    mostrarErrores(opcion) {
      switch (opcion) {
        case 1:
          this.$swal({
            icon: "warning",
            text:
                "Financiamiento no puede ser menor a $" +
                this.montoFinanciamiento,
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          break;
        case 2:
          this.$swal({
            icon: "warning",
            text: "Solo se puede seleccionar una vez efectivo",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          break;
        case 3:
          this.$swal({
            icon: "warning",
            text: "Solo se puede seleccionar una vez financiamiento",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          break;
        case 4:
          this.$swal({
            icon: "warning",
            text: "El monto es mayor",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          break;
        case 5:
          this.$swal({
            icon: "warning",
            text: "No puede ir dos veces esta forma de pago",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          break;
        case 6:
          this.$swal({
            icon: "warning",
            text: "El monto no debe ser mayor al saldo a favor",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          break;
        case 7:
          this.$swal({
            icon: "warning",
            text: "Debes seleccionar una financiera.",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          break;
        default:
          this.$swal({
            icon: "warning",
            text: "Coloque una forma de pago y un monto válido",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
      }
      this.guardando = false;
    },
    obtenerMinimoFinanciera() {
      if (this.financieraSeleccionada !== null) {
        const parametros = {idFinanciera: this.financieraSeleccionada}
        this.formaPagoService
            .obtenerMinimoFinanciera(parametros)
            .then((r) => {
              this.montoFinanciamiento = r;
            });
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    redireccionarCAJA() {
      if (this.$route.name === 'cajaSesion') {
        this.$router.go(0);
      } else {
        this.$router.push({
          name: "cajaSesion",
          params: this.$route.params
        });
        location.reload();
      }
    },
    verificarBloqueo(){
      this.saldoBloqueado = false;
      this.$http.post(this.$api + "ws/reembolsos/existeReembolsoProceso", {"idPaciente": this.idPaciente})
          .then((response) => {
            this.saldoBloqueado = response.data.success;
          });
    },
    limpiarDatosEsquema(){
      this.montoAPagar = "";
      this.formaPagoSeleccionada = null;
    },
    obtenerConfiguracionPlazos() {
      const params = { idClinica: this.$localStorageService.getIdClinica() }
      this.$http.post(this.$api + "plazoFijo/obtenerDetalleMsi/activo", params).then(response => {
        if (response.data.data) {
          this.configuracionesMsi = response.data.data;
        }
      }).finally(()=>{
        this.$http.post(this.$api + "plazoFijo/obtenerIva").then(response => {
          if (response.data.data) {
            this.iva = response.data.data;
          }
        })
      });
    },
    calcularMontosPlazoFijo(){
      this.registroTablaTdc = [];
      if(this.montoAPagar < 1 || this.montoAPagar === ""){
        return;
      }

      if (this.configuracionesMsi.length === 0){
        return;
      }

      this.configuracionesMsi.forEach(item => {
        if (item.estatusMsi || item.aplicaCostoFinanciamiento) {
          let calculo = [];
          let financSinIva = 0;
          let totalFinanMasIVA = 0;
          let costoFinanciamiento = 0;
          let montoFinal = 0;

          if (this.montoAPagar <  item.montoMinimoMsi && !item.aplicaCostoFinanciamiento){
            return;
          }

          if ((this.montoAPagar >= item.montoMinimoMsi && item.estatusMsi) || !item.aplicaCostoFinanciamiento) {
            calculo.meses = item.meses
            calculo.pagoMensual = Math.ceil(this.montoAPagar / item.meses)
            calculo.costoFinanciamiento = 'Sin costo'
            calculo.total = this.montoAPagar
          } else {
            calculo.meses = item.meses
            financSinIva = this.montoAPagar * (item.porcentajeFinanciamiento / 100);
            totalFinanMasIVA = Math.ceil(financSinIva) * Number(this.iva);
            //Truncar a dos decimales el iva
            let ivaTruncado = this.truncarIva(totalFinanMasIVA, 2);
            costoFinanciamiento = Number(Math.ceil(financSinIva)) + ivaTruncado;
            montoFinal = costoFinanciamiento + Number(this.montoAPagar);

            calculo.montoFinanciamiento = Math.ceil(financSinIva);
            calculo.iva = ivaTruncado;
            calculo.pagoMensual = Math.ceil(montoFinal / item.meses);
            calculo.costoFinanciamiento = costoFinanciamiento;
            calculo.total = montoFinal;
          }
          this.registroTablaTdc.push(calculo);
        }
      })
      this.calculoPlazoFijo = true;
    },
    habilitarMonto(){
      this.calculoPlazoFijo = false;
      this.calculoFinancieraAtrato = false;
      this.registroTablaTdc = [];
      this.costoFinanciamientoAtrato = [];
      this.opcionSeleccionada = null;
    },
    truncarIva(x, posiciones){
      var s = x.toString()
      var l = s.length
      var decimalLength = s.indexOf('.') + l
      var numStr = s.substring(0, decimalLength + posiciones)
      return Number(numStr)
    },
    calcularMontosFinanciamiento() {
      this.costoFinanciamientoAtrato = [];
      if(this.opcionesQuincenas.length === 0){
        return;
      }

      this.opcionesQuincenas.forEach(op => {
        let calculo = [];
        let tasaBruta = ((op.tasaNetaAnualidad/100)/24)*(1+(op.impuesto/100));

        let quincenaInversion = tasaBruta * this.montoAPagar;
        let tasaElevada = 1-(Math.pow((1+tasaBruta),-(op.plazoQuincena)));
        let quincenas = quincenaInversion / tasaElevada;
        if (this.montoAPagar >= op.montoMinimo){
          calculo.pagoQuincenal = Math.ceil(quincenas);
          calculo.plazo = op.plazoQuincena;
          this.costoFinanciamientoAtrato.push(calculo);
        }
      })
      this.calculoFinancieraAtrato = true;
    },
    obtenerQuincenasFinaciamientoAtrato() {
      this.opcionesQuincenas = [];
      if(this.montoAPagar < 1 || this.montoAPagar == ""){
        return;
      }
      this.$http.post(this.$api + "atrato/obtenerActivos", this.montoAPagar).then(respuesta => {
        if (respuesta.data.data) {
          this.opcionesQuincenas = respuesta.data.data;
        }
      }).catch(error => {
        console.error(error)
      }).finally(()=>{
        this.calcularMontosFinanciamiento();
      })
    },
    seleccionarTdc(item){
      this.opcionSeleccionada = item;
    },
    obtenerPlazosFinanciamiento(){
      this.$http.post(this.$api + "catalogos/obtener/comisionSpei", {palabraClave: null}).then((respuesta) => {
        if (respuesta.data.data) {
          let financiamientos = respuesta.data.data;
          this.aPlazo = financiamientos.filter(f=>f.idFinanciera == 3 && f.registroActivo);
          this.kueskiPay = financiamientos.filter(f=>f.idFinanciera == 4 && f.registroActivo);
        }
      });
      this.$http.get(this.$api + "financiera/obtener",).then((respuesta) => {
        if (respuesta.data.data) {
          let financiamientos = respuesta.data.data;
          this.dentaliaPayImg = financiamientos.filter(f=>f.idFinanciera == 2 && f.registroActivo).map(f=> f.imagen);
          this.aPlazoImg = financiamientos.filter(f=>f.idFinanciera == 3 && f.registroActivo).map(f=> f.imagen);
          this.kueskiPayImg = financiamientos.filter(f=>f.idFinanciera == 4 && f.registroActivo).map(f=> f.imagen);
        }
      });
    },
    cerrarModalFormas(){
      this.modalFormasPago = false;
      this.esquemaPago = 1;
      this.montoAPagar = "";
      this.formaPagoSeleccionada = null;
      this.financieraSeleccionada = null;
      this.plazoFinancieraSeleccionada = null;
      this.costoFinanciamientoAtrato = [];
      this.registroTablaTdc = [];
      this.opcionSeleccionada = null;
      this.calculoPlazoFijo = false;
      this.calculoFinancieraAtrato = false;
    },

    abrirModalPlazos(){
      this.modalPlazosAbierto = true;
    },
    cerrarModalPlazos(){
      this.modalPlazosAbierto = false;
    },
    inactivarConfiguracionPlazosPti(){
      const envio = {
        idPti: this.idPti,
        idSolicitud: this.idSolicitud
      }
      this.$http.post(this.$api +
          "plazoFijo/inactivarConfiguracionPlazosPti", envio
      ).then((respuesta) => {
        if (respuesta.data.data) {
          console.log(respuesta.data.data);
        }
      }).catch((error) => {
        console.error(error);
      }).finally()
    }
  },
  notifications: {
    showErrorNivelSalud: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer el nivel de salud",
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    showErrorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
}
</script>

<style scoped>
.jello-vertical {
  -webkit-animation: jello-vertical 1.5s infinite both;
  animation: jello-vertical 1.5s infinite both;
}

@-webkit-keyframes jello-vertical {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  40% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  50% {
    -webkit-transform: scale3d(0.85, 1.15, 1);
    transform: scale3d(0.85, 1.15, 1);
  }
  65% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  75% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes jello-vertical {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  40% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  50% {
    -webkit-transform: scale3d(0.85, 1.15, 1);
    transform: scale3d(0.85, 1.15, 1);
  }
  65% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  75% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.fondoMetodosP {
  background-color: #f5f5f5;
}
.v-line-bottom {
  border-bottom: solid 1px #cecece;
  width: 70%;
  position: relative;
}
.v-line-der {
  border-right: thick solid #d0d7da;
  border-width: 1px;
  height: 90%;
  right: 0%;
  position: absolute;
}
</style>
